/* eslint-disable comma-dangle, no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var TextListEditor = require("../components/text-list-editor.jsx");

var HORIZONTAL = "horizontal";
var VERTICAL = "vertical";

var SorterEditor = React.createClass({
    displayName: "SorterEditor",

    propTypes: {
        correct: React.PropTypes.array,
        layout: React.PropTypes.oneOf([HORIZONTAL, VERTICAL]),
        padding: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            correct: ["$x$", "$y$", "$z$"],
            layout: HORIZONTAL,
            padding: true
        };
    },

    render: function render() {
        var editor = this;

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                " ",
                "Correct answer:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Enter the correct answer (in the correct order) here. The preview on the right will have the cards in a randomized order, which is how the student will see them."
                    )
                )
            ),
            React.createElement(TextListEditor, {
                options: this.props.correct,
                onChange: function onChange(options, cb) {
                    editor.props.onChange({ correct: options }, cb);
                },
                layout: this.props.layout
            }),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    " ",
                    "Layout:",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.layout,
                            onChange: this.onLayoutChange
                        },
                        React.createElement(
                            "option",
                            { value: HORIZONTAL },
                            "Horizontal"
                        ),
                        React.createElement(
                            "option",
                            { value: VERTICAL },
                            "Vertical"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use the horizontal layout for short text and small images. The vertical layout is best for longer text and larger images."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(PropCheckBox, {
                    label: "Padding:",
                    padding: this.props.padding,
                    onChange: this.props.onChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Padding is good for text, but not needed for images."
                    )
                )
            )
        );
    },

    onLayoutChange: function onLayoutChange(e) {
        this.props.onChange({ layout: e.target.value });
    },

    serialize: function serialize() {
        return _.pick(this.props, "correct", "layout", "padding");
    }
});

module.exports = SorterEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/sorter-editor.jsx
 ** module id = 149
 ** module chunks = 0 1
 **/